/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'app/utils/loadable';

export const EtfgTearsheetPage = lazyLoad(
  () => import('./index'),
  module => module.EtfgTearsheetPage,
);
